import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { sendMobileOtpValidation } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import MobileValidationOTPModel from "../MobileValidationOTPModel";
import { useService } from "../../../context/ServiceContext";

const MobileValidationOTP = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [mobileData, setMobileData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [mobNumber, setMobNumber] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [verifiedMobileData, setVerifiedMobileData] = useState(null);
  const { serviceName } = useService();
const handleOtpSuccess = (data) => {
  setVerifiedMobileData(data);   // store in parent state
setShowOtpModal(false)
};


  //  Fetch profile data on mount
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data || {});
      } catch (error) {
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  // 🟢 Validate mobile number input
  const validateForm = (mobNumber) => {
    const errors = {};
    if (!mobNumber.trim()) {
      errors.mobNumber = "Mobile number is required.";
    } else if (!/^[1-9][0-9]{9}$/.test(mobNumber)) {
      errors.mobNumber = "Mobile number must be 10 digits and not start with 0.";
    }
    return errors;
  };

  // 🟢 Handle Submit (send OTP)
  const handleSubmit = async () => {
    const validationErrors = validateForm(mobNumber);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      setIsLoading(true);

      const response = await sendMobileOtpValidation({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_number: mobNumber,
        method: "initial",
      });

      const statusCode = response?.status?.code;
      const statusMessage = response?.status?.message || response?.message;

      if (statusCode === 200) {
        setMobileData(response?.data || {});
        showSuccessToast(statusMessage || "OTP sent successfully.");
        setShowOtpModal(true); 
        setErrors({});
      } else {
        const errorMessage =
          response?.message ||
          response?.data?.message ||
          statusMessage ||
          `Something went wrong. (code: ${statusCode})`;
        showErrorToast(errorMessage);
      }
    } catch (error) {
      console.error(" Verify Mobile Error:", error);
      showErrorToast("Failed to send OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}

      {/*  OTP Modal */}
      <MobileValidationOTPModel
        isModalOpen={showOtpModal}
         toggleModal={() => setShowOtpModal(false)}
        mobNumber={mobNumber}
        txnID={mobileData?.txn_id || ""}
        profileData={profileData}
        onSuccess={handleOtpSuccess}  
      />

      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">
        <div className="col-span-2 md:col-span-6 flex justify-end">
          <Link
            to="/TestMaster"
            className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
          >
            <span>Go Back</span>
            <IoArrowBackCircleOutline size={24} />
          </Link>
        </div>

        <InputWithLabel
          type="text"
          label="Mobile Number"
          placeholder="Enter Mobile No"
          maxLength="10"
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="mobile_number"
          id="mobile_number"
          required={true}
          value={mobNumber}
          onChange={(e) => setMobNumber(e.target.value)}
          error={errors.mobNumber}
        />

        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyMob"
            name="verifyMob"
            text={isLoading ? "Verifying..." : "Send OTP"}
            onClick={handleSubmit}
          />
        </div>
      </div>


      {verifiedMobileData && Object.keys(verifiedMobileData).length > 0 && (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-2 px-2 my-2">

    {/* First Half - JSON Response */}
    <div className="bg-white border w-full border-green-300 rounded-md shadow-lg p-2">
  <h2 className="text-lg font-semibold text-yellow-800 mb-2">
    Raw Response (JSON)
  </h2>

  <pre className="text-sm bg-gray-100 p-1 rounded-md 
                  whitespace-pre-wrap break-words overflow-auto max-h-[500px]">
    {JSON.stringify(verifiedMobileData, null, 2)}
  </pre>
</div>


{/* Second Half - Mobile Details */}
<div className="bg-white border border-green-300 rounded-md shadow-lg p-2 w-full ">
  <h2 className="text-xl font-semibold text-green-800 mb-1 border-b pb-2">
    Mobile Details
  </h2>

  {/* IDENTITY DETAILS */}
  <div className="mb-2">
    <h3 className="text-lg font-semibold text-gray-700 mb-2">Identity Details</h3>
    <p><span className="font-semibold">Name:</span> {verifiedMobileData?.report?.result?.identity_details?.name}</p>
    <p><span className="font-semibold">DOB:</span> {verifiedMobileData?.report?.result?.identity_details?.date_of_birth}</p>
  </div>



<div className="grid grid-cols-1 md:grid-cols-3 gap-3">
  {/* CONTACT DETAILS */}
  <div className="p-3 border rounded bg-gray-50 shadow-sm">
    <h3 className="text-lg font-semibold text-gray-700 mb-2">Contact Details</h3>

    <p><span className="font-semibold">Registered Mobile:</span> {verifiedMobileData?.report?.result?.contact_details?.registered_contact}</p>
    <p><span className="font-semibold">Alternate (Work):</span> {verifiedMobileData?.report?.result?.contact_details?.alt_contact_work}</p>
    <p><span className="font-semibold">Email:</span> {verifiedMobileData?.report?.result?.contact_details?.email_id}</p>

    <p className="mt-2">
      <span className="font-semibold">Permanent Address:</span><br />
      {verifiedMobileData?.report?.result?.contact_details?.permanent_address}
    </p>
  </div>

  {/* SIM DETAILS */}
  <div className="p-3 border rounded bg-gray-50 shadow-sm">
    <h3 className="text-lg font-semibold text-gray-700 mb-2">SIM Details</h3>

    <p><span className="font-semibold">Operator:</span> {verifiedMobileData?.report?.result?.sim_details?.operator}</p>
    <p><span className="font-semibold">Service Type:</span> {verifiedMobileData?.report?.result?.sim_details?.service_type}</p>
    <p><span className="font-semibold">Network:</span> {verifiedMobileData?.report?.result?.sim_details?.network_type}</p>
    <p><span className="font-semibold">Status:</span> {verifiedMobileData?.report?.result?.sim_details?.status}</p>
  </div>

  {/* PLAN DETAILS */}
  <div className="p-3 border rounded bg-gray-50 shadow-sm">
    <h3 className="text-lg font-semibold text-gray-700 mb-2">Current Plan Details</h3>

    <p><span className="font-semibold">Plan:</span> {verifiedMobileData?.report?.result?.plan_details?.customer_plan}</p>
    <p><span className="font-semibold">Daily Data:</span> {verifiedMobileData?.report?.result?.plan_details?.daily_data_balance}</p>
    <p><span className="font-semibold">Balance:</span> {verifiedMobileData?.report?.result?.plan_details?.balance}</p>
  </div>
</div>


<div className="mb-2">
  <h3 className="text-lg font-semibold text-gray-700 mb-2">
    Recent Recharge History
  </h3>

  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
    {verifiedMobileData?.report?.result?.history?.recharge_history
      ?.slice(0, 5)
      .map((item, index) => (
        <div
          key={index}
          className="p-3 border rounded-lg bg-gray-50 shadow-sm"
        >
          <p>
            <span className="font-semibold">Plan:</span> {item.plan_name}
          </p>
          <p>
            <span className="font-semibold">Start:</span> {item.plan_start_date}
          </p>
          <p>
            <span className="font-semibold">End:</span> {item.plan_end_date}
          </p>
          <p>
            <span className="font-semibold">Status:</span>{" "}
            <span
              className={
                item.plan_status === "Active"
                  ? "text-green-600 font-bold"
                  : "text-red-600 font-bold"
              }
            >
              {item.plan_status}
            </span>
          </p>
        </div>
      ))}
  </div>
</div>


  {/* LINKED ACCOUNTS */}
  <div>
    <h3 className="text-lg font-semibold text-gray-700 mb-2">Linked Accounts</h3>
    <ul className="list-disc ml-5">
      {verifiedMobileData?.report?.result?.linked_account_details?.map((acc, i) => (
        <li key={i}>
          {acc.customer_name} — {acc.customer_registered_number}
        </li>
      ))}
    </ul>
  </div>

</div>

  </div>
)}

    </>
  );
};

export default MobileValidationOTP;
